/**
 * Shrimp
 *
 * © Kirill Murashov 2013
 *
 * Simple library for DOM manipulation
 *
 */
(function () {

	DURATION_PREFIX = Modernizr.prefixed('transitionDuration');
	TRANSFORM_PREFIX = Modernizr.prefixed('transform');
	HTML5 = (Modernizr.csstransforms || Modernizr.csstransforms3d) && Modernizr.csstransitions;

	window.shrimp = {};
	/**
	 * IndexOf for old browsers
	 * @param array
	 * @param item
	 * @returns {number}
	 */
	function indexOf(array, item){
		if (array == null) return -1;
		var i, l;
		for (i = 0, l = array.length; i < l; i++) if (i in array && array[i] === item) return i;
		return -1;
	}


	/**
	 *
	 * Prototype for DOM manipulation
	 *
	 * @param el
	 * @constructor
	 */
	function Dom(el){
		this.el = el;
	}

	Dom.prototype = {
		/*Simple DOM manipulation*/
		setClass: function (className) {
			this.attr('class', className);
			return this;
		},
		addClass: function (className) {
			var currClassName = this.attr('class');
			if (currClassName === null || "undefined" === typeof currClassName) {
				this.attr('class', className);
			} else if (currClassName.indexOf(className) < 0) {
				this.attr('class', currClassName + ' ' + className);
			}
			return this;
		},
		removeClass: function (className) {
			var reg = new RegExp(className, 'g'),
				currClassName = this.attr('class');

			this.attr('class', currClassName.replace(reg, ''));

			return this;
		},
		toggleClass: function (className) {
			var currClassName = this.attr('class');
			var currArrayClassName = currClassName !== null ? currClassName.split(' ') : [];
			var num = indexOf(currArrayClassName, className);
			if (num === -1) {
				this.addClass(className)
			} else {
				currArrayClassName.splice(num, 1);
				this.setClass(currArrayClassName.join(' '));
			}
			return this;
		},
		/*Insert element in DOM*/
		insert: function (targetEl) {

			if (typeof targetEl === 'string') {
				targetEl = document.getElementById(targetEl);
			}else{
				targetEl = targetEl.el || targetEl;
			}

			targetEl.appendChild(this.el);
			return this;
		},
		/*Set attribute for DOM element*/
		attr: function (attrName, attrVal) {
			if (typeof attrVal !== 'undefined') {
				this.el.setAttribute(attrName, attrVal);
				return this;
			} else {
				return this.el.getAttribute(attrName);
			}
		},
		/*Delete element from DOM*/
		del: function () {
			this.el.parentNode.removeChild(this.el);
			this.el = null;
			return 1;
		},
		/*Set styles for DOM element*/
		css: function (cssRules) {

			for (var i in cssRules) {
				this.style(i, cssRules[i]);
			}
			return this;
		},
		/*Set style for DOM element*/
		style: function (styleName, styleVal) {
			this.el.style[styleName] = styleVal;
			return this;
		},
		/*Set text node for DOM element*/
		setText: function(text){
			this.el.appendChild(document.createTextNode(text));
			return this;
		},
		/*Empties an Element of all its children*/
		clear: function(){
			var childs = this.el.childNodes;
			for(var i=0, l=childs.length; i<l; i++){
				this.el.removeChild(childs[i]);
			}
			return this;
		},

		animationDuration: function(time){
			if(HTML5){
				this.style(DURATION_PREFIX, time + 'ms');
			}else{
				this.duration = time;
			}
		},

		getChildrens: function(tagName){
			tagName = tagName || '*';
			return this.el.getElementsByTagName(tagName);
		},

		transform: function(fx){

			fx.x = fx.x || 0;
			fx.y = fx.y || 0;
			fx.z = fx.z || 0;

			if(HTML5){
				this.style(TRANSFORM_PREFIX, Modernizr.csstransforms3d ? 'translate3d('+ fx.x +'px, '+ fx.y +'px, '+ fx.z +'px)' : 'translate('+ fx.x +'px, '+ fx.y +'px)');
			}else{
				document.id(this.el).set('morph', {duration: 'short', transition: 'linear'});
				document.id(this.el).morph({top: fx.y, left: fx.x});
			}
		}
	};

	/**
	 * Cross-browser Events
	 */
	if(typeof Hammer !== 'undefined' && !!window.addEventListener){
		Dom.prototype.on = function(eventName,callback){
			Hammer(this.el).on(eventName, callback);
		};
		Dom.prototype.off = function(eventName,callback){
			Hammer(this.el).off(eventName, callback);
		};
		Dom.prototype.trigger = function(eventName, eventData){
			Hammer(this.el).trigger(eventName, eventData);
		};

	}else if(!!window.addEventListener){
		window._ready = function(callbackFunction){
			window.addEventListener('DOMContentLoaded',callbackFunction);
		};
		Dom.prototype.on = function(eventName,callback){
			this.el.addEventListener(eventName,callback,false);
		};
		Dom.prototype.off = function(eventName,callback){
			this.el.removeEventListener(eventName,callback);
		};
	}else if(!!window.attachEvent){
		window._ready = function(callbackFunction){
			window.attachEvent('onload',callbackFunction);
		};
		Dom.prototype.on = function(eventName,callback){
			if(eventName === 'tap'){
				eventName='click';
			}
			if(eventName.indexOf('drag') !== -1){
				return
			}
			this.el.attachEvent('on'+eventName,callback);
		};
		Dom.prototype.off = function(eventName,callback){
			this.el.detachEvent('on'+eventName,callback);
		};
	}

	/**
	 *
	 * Getting the element by its id, class name or tag name.
	 * Return DOM element or Array of DOM elements
	 *
	 * @param id
	 * @param context
	 * @returns {*}
	 * @public
	 */
	window._dom = function (id, context) {
		context = context ? (context.el || context) : document;
		if(typeof id !== 'string'){
			return new Dom(id);
		}
		if (id.substr(0, 1) == '.') {
			var className = id.substr(1);
			if (typeof context.getElementsByClassName === 'function') {
				var resultArray = [];
				var arrayOfElements = context.getElementsByClassName(className);

				//for (var i in arrayOfElements) if (Object.prototype.hasOwnProperty.call(arrayOfElements, i) && typeof arrayOfElements[i] === 'object') {
				for(var i = 0, l = arrayOfElements.length; i < l; i++){
					resultArray.push(new Dom(arrayOfElements[i]));
				}
				return resultArray;
			} else {
				resultArray = [];
				arrayOfElements = context.getElementsByTagName('*');
				for (var i in arrayOfElements) if (Object.prototype.hasOwnProperty.call(arrayOfElements, i) && typeof arrayOfElements[i] === 'object') {
					var currClassName = arrayOfElements[i].getAttribute('class');
					var arrayOfClasses = currClassName === null ? [] : currClassName.split(' ');
					if (indexOf(arrayOfClasses, className) !== -1) {
						resultArray.push(new Dom(arrayOfElements[i]));
					}
				}
				return resultArray;
			}
		} else if (id.substr(0, 1) == '#') {
			var el = context.getElementById(id.substr(1));
			return new Dom(el);
		} else {
			resultArray = [];
			arrayOfElements = context.getElementsByTagName(id);
			for (var i in arrayOfElements) if (Object.prototype.hasOwnProperty.call(arrayOfElements, i) && typeof arrayOfElements[i] === 'object') {
				resultArray.push(new Dom(arrayOfElements[i]));
			}
			return resultArray;
		}
	};

	/**
	 * Create new Element
	 * @param tag
	 * @param properties
	 * @returns {Dom}
	 * @private
	 */
	window._newEl = function (tag, properties) {
		properties = properties || {};
		if ("string" == typeof tag) {
			var el = new Dom(document.createElement(tag));
		} else {
			el = new Dom(tag);
		}
		if (typeof properties.styles !== 'undefined') {
			el.css(properties.styles);
			delete properties.styles;
		};
		for (var i in properties) {
			el.attr(i, properties[i]);
		}
		return el;
	};
})();

var CallbackRegistry = {};
_ajax = function(options){

	options = options || {};
	var type = options.type || 'GET';
	var url = options.url;
	var processData = options.processData === undefined ? true : !!options.processData;

	if(type === 'JSONP'){

		var callbackName = 'f'+String(Math.random()).slice(2);
		options.url += ~options.url.indexOf('?') ? '&' : '?';
		options.url += 'callback=CallbackRegistry.'+callbackName;
		CallbackRegistry[callbackName] = function(data) {
			delete CallbackRegistry[callbackName];
			options.success(data);
		};

		var elem = document.createElement("script");
		elem.src = options.url;
		document.getElementsByTagName('head')[0].appendChild(elem);

		return
	}



	// Process the data for sending.
	var data = options.data;
	if (processData && typeof data === 'object'){
		var params = Object.keys(data).map(function(prop){
			return encodeURIComponent(prop) + '=' + encodeURIComponent(data[prop]);
		});
		data = params.join('&');
	}

	// Data for GET and HEAD goes in the URL.
	if (data && (type === 'GET' || type === 'HEAD')){
		url += (url.indexOf('?') === -1 ? '?' : '&') + data;
		data = undefined;
	}

	var xhr = new XMLHttpRequest();

	xhr.open(type, url, true);

	if (options.contentType) xhr.setRequestHeader('Content-Type', options.contentType);
	if (options.beforeSend) options.beforeSend(xhr);

	xhr.onload = function(){
		var error = false;
		var content = xhr.responseText;

		// Parse the JSON before calling success.
		if (options.dataType === 'json'){
			try {
				content = JSON.parse(content);
			} catch (e){
				error = true
			}
		}

		if (!error && (xhr.status >= 200 && xhr.status < 300)){
			// The last two arguments only apply to v0.9.2.
			if (options.success) options.success(content, xhr.statusText, xhr);
		} else {
			// This signature is inconsistent with v0.9.2, but is correct for 1.0.0.
			if (options.error) options.error(xhr);
		}
	}.bind(this);

	xhr.onerror = xhr.onabort = function(){
		if (options.error) options.error(xhr);
	};

	xhr.send(data);


	return xhr;
};